// extracted by mini-css-extract-plugin
export default {"containerError":"styles_containerError__kkzwJ","containerImage":"styles_containerImage__Su5+I"};